import { BasicDialogProperties } from "../../../../basic/view/dialogs/BasicDialogProperties";

export class Poker2TournamentRebuyDialogProperties extends BasicDialogProperties {
    public tournamentId: number = 0;
    public tournamentName: string;
    public chips: number = NaN;
    public gold: number = NaN;

    constructor(tournamentId: number, tournamentName: string, chips: number, gold: number) {
        super();

        this.tournamentId = tournamentId;
        this.tournamentName = tournamentName;
        this.chips = chips;
        this.gold = gold;
    }
}
